// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { PaymentTerm } from '@/payment-term/api/types';

// Sentinel used when an invoice has a stored paymentTerms label that does
// not match any known PaymentTerm — for example a custom label that was
// set before the enum was locked down. We surface it as a "Custom" option
// in the dropdown so the user can see what's there, keep it untouched, or
// replace it with a real term. Any change away from the sentinel discards
// it and replaces it with a real PaymentTerm.
const CUSTOM_PAYMENT_TERM_ID = '__custom_payment_term__';

export function isCustomPaymentTerm(term: PaymentTerm | null): boolean {
  return term !== null && term.id === CUSTOM_PAYMENT_TERM_ID;
}

export function makeCustomPaymentTerm(label: string): PaymentTerm {
  return {
    id: CUSTOM_PAYMENT_TERM_ID,
    key: 'custom',
    label,
    value: 'custom',
    netDays: null,
  };
}
